// Setup › Connected systems on the SettingsPage pattern (BL-189): the accounting system the books are
// exported to and the export itself (books/AccountingSystem.tsx, which Accounting › Ledger and reports
// draws too when the provider sends the office back). As Settings.tsx drew Connections in Blueprint, on
// catalogued parts. Riverstone keeps Connections in Settings.tsx.
import { SettingsPage } from '@flowology/ui-web/patterns';
import { AccountingSystem } from '../books/AccountingSystem.tsx';
import { useToast } from '../books/ui.tsx';
import { PageBanners, usePageCrumb, type NavProps } from '../Nav.tsx';
import { BP_LEDE } from './ledes.ts';
import { settingsPage } from './parts.ts';

export function ConnectionsPage({ nav, timeZone }: { nav: NavProps; timeZone: string }) {
  const crumb = usePageCrumb(nav);
  const [toast, setToast] = useToast();
  return (
    <div className="app">
      {/* the sheet pads the page (blueprint.css .bp-sheet), as PageFrame does; no .page padding on top */}
      <main>
        <PageBanners nav={nav} />
        <SettingsPage
          head={{
            ...(crumb ? { crumb } : {}),
            title: settingsPage('connections').label ?? 'Connected systems',
            lede: BP_LEDE.connections,
          }}
        >
          <AccountingSystem toast={setToast} timeZone={timeZone} />
        </SettingsPage>
        {toast && (
          <div className="toast" role="status">
            {toast}
          </div>
        )}
      </main>
    </div>
  );
}
